export const appendElement = (
    element: string,
    attrs: Record<string, string>,
    to: string
): HTMLElement => {
    const e = document.createElement(element);
    Object.entries(attrs).forEach(([key, val]) => {
        e.setAttribute(key, val);
    });
    const parent = document.getElementById(to);
    if (parent) parent.appendChild(e);
    return e;
};

export function downloadBlob(blob: Blob, name: string): void {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = name;
    document.body.appendChild(link);
    link.dispatchEvent(new MouseEvent('click'));
    document.body.removeChild(link);
}

export function appendScript(
    src: string,
    id?: string,
    onload?: () => void
): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = src;
    if (id) script.id = id;
    if (onload) script.addEventListener('load', onload);
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
}

export const getMetaDescription = () => {
    const meta = document.querySelector(
        'meta[name="description"]'
    ) as HTMLMetaElement;
    return meta.content;
};

export const getPageTitle = () => {
    return document ? document.title : 'Alude';
};

export function setMetaDescription(content: string) {
    const meta = document.querySelector('meta[name="description"]');
    if (meta instanceof HTMLMetaElement) {
        const originalContent = meta.content;
        meta.content = content;
        return originalContent;
    }
}

export function setTitle(title: string) {
    const originalTitle = document.title;
    document.title = title;
    return originalTitle;
}
